export const sum = (a, b) => a + b;
export const gcd = (a, b) => b === 0 ? a : gcd(b, a % b);
export const normalize = val => val / 100;
export const denormalize = val => val * 100;
export const inverseNormalize = val => 1 / normalize(val);
export const sortNumbers = (a,b) => Number(a) - Number(b);

// assumes end value is always greater than start
export const distance = (start, end, current) => {
    if (current >= end) {
        return 1;
    }

    if (current <= start) {
        return 0;
    }

    return Math.abs(current - start) / Math.abs(end - start);
};

export const interpolate = (start, end, location) => location * (end - start) + start;

export const findNearestBounds = (subject = 0, available = {}) => {
    const lowerKey = Object.keys(available).sort(sortNumbers).reverse().find(item => item <= subject),
        upperKey = Object.keys(available).sort(sortNumbers).find(item => item > subject);

    return {
        lowerKey,
        upperKey
    }
}